<template>
  <div class="item">
    <div class="label">
      <div class="tit" :style="{width:labelWidth!==0?labelWidth+'px':'',color:leftColor}">{{label}}</div>
      <div :style="{color:ctnColor,textAlign:textAlign}" class="con-text"><slot /></div>
    </div>
    <img class="img" v-if="showRight" src="@/assets/travelAgency/right.png">
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            labelWidth: {
                type: Number,
                default: 0
            },
            label: {
                type: String,
                default: ''
            },
            textAlign: {
                type: String,
                default: ''
            },
            ctnColor: {
                type: String,
                default: ''
            },
            showRight: {
                type: Boolean,
                default: true
            },
            leftColor: {
                type: String,
                default: ''
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
   .item {
    padding:12px 16px 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .label {
      flex: 1;
      display: flex;
      align-items: flex-start;
      .tit {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
        min-width: 42px;
      }
      .con-text{
        flex: 1;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .img {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }
</style>
